import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import AdSchoolInfoManager from "../../services/system/school-info/ad-school-info-manager";
import {toast} from "react-toastify";
import YearController from "../../services/data-declaration/year-controller";
import {isBrowser } from 'react-device-detect';
import AdminController from "../../services/system/admin-controller";
import {
    getAccessToken,
    getSchoolId,
    getSchoolYear,
    setAccessToken,
    setSchoolAbbreviationName,
    setSchoolId,
    setSchoolYear,
    setSchoolYearName
} from "../../utils/authority";
class PageHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            separator: "/",
            title:'SAS School Service',
            fontSize: 13,
            color: '#C6C6C6',
            ListSchool: [],
            ListYear: [],
            router: [],
            yearId: 0,
            schoolId: 0,
            pageNumber: 0,
            pageSize: 1000,
        }
    }

    componentDidMount() {
        this.setState({
            schoolId: getSchoolId(),
            yearId: getSchoolYear()
        });
        let {title} = this.props;
        document.title = !title ? "SAS School Service" : (title+" - SAS School Service");
        this.getListYears();
        this.getListSchool();
        if (getSchoolId() === undefined){
            this.getListSchool();
        }
    }
    renderSchool = () => {
        return this.state.ListSchool.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    renderYear = () => {
        return this.state.ListYear.map((item, index) => <option
            value={item.id}>{item.year}-{parseInt(item.year)+1}</option>)
    };
    getListSchool = () => {
        let {pageNumber, pageSize} = this.state;
        let payload = {
            pageNumber: pageNumber,
            pageSize: pageSize,
            "sort": "created_at desc"
        };
        AdSchoolInfoManager.getListSchool(payload, res => {
            if (res.success) {
                this.setState({
                    ListSchool: res.data.content,
                    showLoading: false
                });
                if (res.data.content.length > 0){
                    setSchoolId(res.data.content[0].id)
                    setSchoolAbbreviationName(res.data.content[0].abbreviationName)
                    this.setState({
                        schoolId: res.data.content[0].id,
                    });
                }
            }else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    };
    getListYears = () => {
        let {pageNumber, pageSize} = this.state;
        let payload = {
            pageNumber: pageNumber,
            pageSize: pageSize,
            "sort": "created_at desc"
        };
        YearController.getListYear(payload, res => {
            if (res.success) {
                if (res.data.content.length > 0 && (getSchoolYear() === undefined || getSchoolYear() < 0)){
                    this.setState({
                        yearId: res.data.content[0].id,
                        showLoading: false
                    });
                    setSchoolYear(res.data.content[0].id)
                    setSchoolYearName(res.data.content[0].year+"-"+(parseInt(res.data.content[0].year)+1))
                }
                this.setState({
                    ListYear: res.data.content,
                    showLoading: false
                });
            }else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    };
    selectSchool = (schoolId) => {
        AdminController.selectSchool(schoolId, res => {
            if (res.success) {
                let day = this.state.remember ? 7 : 1;
                setAccessToken(res.data, day);
            }else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
            window.location.reload();
        })
    };

    render() {
        let {fontSize,color} = this.state;
        let {title,separator,titleStyle,titleClassName,routerEnable,router, isShowLevel} = this.props;
        return (
            <div className="row">
                <div className="col-xs-8 col-sm-8 col-md-8 p-0 pr-md-3 d-flex"  style={{
                    alignItems: "center",
                    justifyContent: "left"
                }}>
                    {routerEnable && <div className="d-flex mb-4 align-items-center">
                        <Link style={!titleStyle ? {fontSize} : titleStyle} color="inherit" to={{pathname: '/ad-sas-school',}}>{'Trang chủ'}</Link>
                        <span style={{fontSize,color}}  className="ml-1 mr-1">{!separator ? "/" : separator}</span>
                        {router && router.map((obj,index)=>{
                            return(
                            <div className={!titleClassName ? "d-flex align-items-center" : titleClassName}>
                                    <Link style={!titleStyle ? {fontSize} : titleStyle} color="inherit" to={{
                                        pathname: obj.pathname,
                                    }}>
                                        {obj.name}
                                    </Link>
                                    <span style={{fontSize,color}}  className="ml-1 mr-1">
                                        {!separator ? "/" : separator}
                                    </span>
                                </div>
                            )
                        })}
                        <Typography color="textPrimary" style={{fontSize}}>{title}</Typography>
                    </div>
                    }
                </div>
                <div className="col-xs-4 col-sm-4 col-md-4 p-0 pr-md-3 d-flex" style={{
                    alignItems: "center",
                    justifyContent: "right"
                }}>
                    {/*{this.state.ListSchool.length > 1 &&*/}
                    {/*<div className='d-inline-flex' style={{lineHeight: '28px', marginRight: '22px'}}>*/}
                    {/*        <span className="d-flex justify-content-start">*/}
                    {/*            Trường*/}
                    {/*        </span>*/}
                    {/*        <select*/}
                    {/*            className="form-control pd-4-input ml-1"*/}
                    {/*            style={{*/}
                    {/*                height: 26, width: 100, fontSize: 12*/}
                    {/*            }}*/}
                    {/*            value={this.state.schoolId}*/}
                    {/*            defaultValue={6}*/}
                    {/*            onChange={(e) => {*/}
                    {/*                this.setState({*/}
                    {/*                    schoolId: e.target.value,*/}
                    {/*                })*/}
                    {/*                setSchoolId(e.target.value)*/}
                    {/*                this.selectSchool(e.target.value)*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            <option value="-1">Tất cả</option>*/}
                    {/*            {this.renderSchool()}*/}
                    {/*        </select>*/}
                    {/*</div>}*/}
                    <div className='d-inline-flex' style={{lineHeight: '28px'}}>
                            <span className="d-flex justify-content-start">
                                {isBrowser ? "Năm học": "Năm"}
                            </span>
                        <select
                            className="form-control pd-4-input ml-1"
                            style={{
                                height: 26, width: 100, fontSize: 12
                            }}
                            value={this.state.yearId}
                            defaultValue={6}
                            onChange={(e) => {
                                this.setState({
                                    yearId: e.target.value,
                                })

                                setSchoolYear(e.target.value);
                                setSchoolYearName(e.target.options[e.target.selectedIndex].text);
                                window.location.reload();
                            }}
                        >
                            <option value="-1">Tất cả</option>
                            {this.renderYear()}
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}

export default PageHeader;
